import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { throwIfEmpty } from 'rxjs/operators';
import { Project } from '../../shared/models/projects/project.model';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ProjectService {
  private baseUrl: string = environment.baseUrl + 'v2.0/projects/';

  constructor( private http: HttpClient) { }

  public getProject = (id: string) => this.http.get<Project>(`${this.baseUrl}${id}`);

  public getProjects(): Observable<Project[]> {
    return <Observable<Project[]>>this.http.get<Project[]>(this.baseUrl)
      .pipe(
        throwIfEmpty(() => new Error('no projects found'))
      );
  }
}
